module.exports = __webpack_public_path__ + "static/section2-da451a39ee6e73c1833e51e214cd5844.svg";